<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <main class="common-main">
      <!-- 認証済みの時はメインの画面を表示 -->
      <template v-if="signedIn">
        <!-- 認証済みの時はメインの画面を表示 -->
        <template v-if="isLoading">
          <div class="loading"></div>
        </template>
        <template v-else-if="isOwnProfile">
          <br>
          <template v-if="isAdviser || isStaff">
          </template>
          <template v-else>
            <a href="/counselingDetail"><button class="footerNavi-button button-primary">新規相談をする</button></a>
            <br>
          </template>
          <div class="profile-box">
            <span class="icon"><img :src="profileIconUrl" width="92px"></span>
            <span class="name">{{profileDisplayName}}</span>
            <span class="survive" v-if="enableSurviveModule"><span class="label">サバイバー歴</span> {{surviveDate}}</span>
            <template v-if="paymentActiveStatus">
              <span class="payment">{{paymentMode}}</span>
              <template v-if="!paymentManagementButtonHidden">
                <form v-if="paymentMode === '有料プランご利用中'" :action="paymentCustomerPortalApiUrl" method="POST">
                  <input type="hidden" name="customerId" :value="paymentCustomerId" />
                  <button type="submit">支払いの管理</button>
                </form>
                <div v-else  class="item">
                  <a href="/payment"><button class="footerNavi-button button-primary">有料プラン（月額3,980円）を利用開始</button></a>
                </div>
              </template>
            </template>
          </div>

          <h2 class="common-title">プロフィール</h2>
          <div class="profile-detail">
            <ul>
              <li><b>性別</b>： {{profileGender}}</li>
              <li><b>年齢</b>： {{profileAge}}</li>
              <li><b>続柄</b>： {{profileRelationship}}</li>
              <li><b>がん種</b>： {{profileCancerType}}</li>
              <li><b>ステージ</b>： {{profileCancerStage}}</li>
              <li><b>がんが発見されたきっかけ</b>： {{profileDiagnosedReason}}</li>
              <li><b>がんと診断された年月日</b>： {{profileDiagnosedDate}}</li>
              <li><b>現在かかっている病院・診療科</b>： {{profileHospitalName}}</li>
              <li><b>現在の状況</b>： {{profileCurativeStatus}}</li>
              <li v-if="isNew"><b>罹患歴</b>： {{profileCancerHistory}}</li>
              <li v-if="appClass === 'hama'"><b>研究（アンケート調査）への同意</b>： <template v-if="consentHamaMEDResearch === 'agree'">同意する</template><template v-else>同意しない</template></li>
              <li v-if="appClass === 'hama'"><b>浜松医科大学医学部附属病院の診察券番号</b>： {{patientIdHamaMEDHospital}}</li>
            </ul>
          </div>

          <template v-if="isStaff">
          </template>
          <template v-else>
            <dl class="item">
              <a href="/profileSetting"><button class="footerNavi-button button-secondary">プロフィールを編集する</button></a>
            </dl>
          </template>

          <h2 class="common-title">タイムライン</h2>
          <template v-if="isNew">
            <h4 class="item">
              タイムラインはまだ記入されていません
            </h4>
          </template>
          <template v-else>
            <div class="timeline" v-for="timelineContent in timelineContents" :key="timelineContent.id">
              <dl class="item timeline-module" v-bind:class='{future:timelineContent.isFuture}'>
                <dt class="term">{{timelineContent.selectedStartYear}}年{{timelineContent.selectedStartMonth}}月
                  <template v-if="!timelineContent.isStill"> - {{timelineContent.selectedEndYear}}年{{timelineContent.selectedEndMonth}}月</template>
                  <template v-if="timelineContent.isFuture">
                    <span class="futre">未来</span>
                  </template>
                  <template v-else-if="!timelineContent.isSpecialContent">
                    <template v-if="timelineContent.isStill">
                      <span class="still">現在継続中</span>
                    </template>
                  </template>
                </dt>
                <dd class="category1"><span class="category1-content">{{timelineContent.selectedCategory1}}</span></dd>
                <dd class="category2"><span class="category2-content">{{timelineContent.selectedCategory2}}</span></dd>
                <dd class="memo">{{timelineContent.memo}}</dd>
              </dl>

            </div>
          </template>

          <template v-if="isStaff">
          </template>
          <template v-else>
            <dl class="item">
              <a href="/timeline"><button class="footerNavi-button button-secondary">タイムラインを編集する</button></a>
            </dl>
          </template>
        </template>
        <template v-else>
          <div class="text-box">
            {{loadMessage}}
          </div>
        </template>
      </template>

      <!-- 認証していない時はログイン画面を表示 -->
      <template v-else>
        <LoginItem :createButton="false" />
      </template>
    </main>
    <template v-if="isAdviser || isStaff">
      <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
    </template>
    <template v-else>
      <FooterItem :contactUrl="contactUrl" />
    </template>
  </div>
</template>

<script>
import { API, Auth, Storage, graphqlOperation, Analytics, Logger } from "aws-amplify"
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'

import { getUser } from "./graphql/queries"
import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { listUsersBySpecificUser } from "./graphql/queries"
import { createErrorLog } from "./graphql/mutations"
import { listTimelinesBySpecificUser } from './graphql/queries'
import moment from 'moment'

import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

const logger = new Logger('Profile');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'profile',
  components : {
    HeaderItem,
    FooterItem,
    LoginItem
  },
  mixins:[Common],
  data(){
    return{
      authState: undefined,
      unsubscribeAuth: undefined,
      signedIn: false,
      id: '',
      mailaddress: '',
      userType: '',
      isAdviser: false,
      isStaff: false,
      hasUserData: false,
      isOwnProfile: false,
      profileGender: '',
      profileAge: '',
      profileRelationship: '',
      profileCancerType: '',
      profileCancerStage: '',
      profileDiagnosedReason: '',
      profileDiagnosedDate: '',
      profileHospitalName: '',
      profileCurativeStatus: '',
      profileCancerHistory: '',
      profileContactUrl: '',
      profileDisplayName: '',
      profileIconUrl: '',
      enableSurviveModule: false,
      surviveDate: '-',
      isNew: false,
      timelineContents: [],
      isLoading: true,
      loadMessage: '',
      paymentMode: '',
      paymentCustomerId: '',
      paymentSubscriptionStatus: '',
      paymentSubscriptionStartAt: '',
      paymentSubscriptionEndAt: '',
      paymentManagementButtonHidden: false,
      paymentActiveStatus: false,
      paymentCustomerPortalApiUrl: '',
      appClass: '',
      consentHamaMEDResearch: '',
      patientIdHamaMEDHospital: '',
    }
  },
  
  filters: {

  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },
  
  created () {
    this.refresh()
  },
  
  methods: {
    refresh () {
      Storage.list('')
        .then(result => 
          this.s3Data = JSON.parse(JSON.stringify(result))
        )
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'Profile',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              counselingTopicsId: this.counselingId,
              errorType: 'Image List : Storage.list',
              errorNumber: 'Profile-01',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'Profile',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            counselingTopicsId: this.counselingId,
            errorType: 'Image List : Storage.list',
            errorNumber: 'Profile-01',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
        });
    },

    download(key, identityId) {
      Storage.get(key, { level: 'protected', identityId: identityId })
        .then(result => {
          //console.log(result)
          
          if (!key) {
            result = null
          }
          this.profileIconUrl = result

          if (!this.profileIconUrl) {
            this.profileIconUrl = this.profileIconDefaultUrl
          }
          if (!this.profileIconUrl) {
            this.profileIconUrl = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/default-profile-img.png'
          }
 
        })
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'Profile',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Image download : Storage.get',
              errorNumber: 'Profile-02',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'Profile',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image download : Storage.get',
            errorNumber: 'Profile-02',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
          alert("画像の取得処理に失敗しました")
        })
    },

    getAge: function(birthDate) {
      var today = new Date()
      var tdate = ( today.getFullYear() * 10000 ) + (( today.getMonth() + 1 ) * 100 ) + today.getDate()
      var age = Math.floor(( tdate - birthDate.replace(/-/g, '') ) / 10000 )
      return age
    },
  },

  mounted : function(){
    this.appClass = this.getAppDivClass(location.hostname)
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });

    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email

      let currentCredentials = await Auth.currentCredentials()
      this.identityId = currentCredentials.identityId
    } catch (err) {
      this.signedIn = false
      this.loadMessage = '権限がありません'
      this.isLoading = false
    }
    
    // 認証情報でUserデータを確認 
    try {
      let userData = await API.graphql(graphqlOperation(
        listUsersBySpecificUser, {mailAddress: this.mailaddress, limit: 1}
      ))
      this.userId = userData.data.listUsersBySpecificUser.items[0].id
      this.userType = userData.data.listUsersBySpecificUser.items[0].type

      if (userData.data.listUsersBySpecificUser.items[0].type === 'adviser') {
        this.isAdviser = true
      } else {
        this.isAdviser = false
      }
      if (userData.data.listUsersBySpecificUser.items[0].id) {
          this.hasUserData = true 
      }
      let env = this.getEnv(location.hostname)
      this.appClass = this.getAppDivClass(location.hostname)
      if (this.appClass === 'hama') {
        this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // 浜松オンラインがん相談版
      } else {
        this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // CancerWith版
      }
      if (this.$route.params.userId === this.userId || this.isAdviser) {
        this.isOwnProfile = true
      } else {
        this.isOwnProfile = false
        this.loadMessage = '権限がありません'
        this.isLoading = false
      }
    } catch (err) {
      // 運営アカウントか判定
      try {
        let staffAllowData = await API.graphql(
          graphqlOperation(listStaffAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )
        if (
          staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          // 運営モード
          this.userId = ''
          this.userType = 'adviser'
          this.isAdviser = false
          this.isStaff = true
          this.hasUserData = true
          this.contactUrl = ''
          this.isOwnProfile = true
        } else {
          this.userId = ''
          this.userType = ''
          this.isAdviser = false
          this.isStaff = false
          this.hasUserData = false
          this.contactUrl = ''
        }
      } catch (err) {
        this.userId = ''
        this.userType = ''
        this.isAdviser = false
        this.isStaff = false
        this.hasUserData = false
        this.contactUrl = ''
      }
    }

    // プロフィール・タイムライン・支払いステータス取得
    if (this.isOwnProfile) {
      // プロフィールデータの取得
      try {
        let counselingUserData = await API.graphql(graphqlOperation(
          getUser, {id: this.$route.params.userId, limit: 1}
        ))

        // 課金モードの確認
        this.paymentActiveStatus = this.getPaymentActiveStatus(location.hostname)

        // 支払いステータス
        if (this.paymentActiveStatus) {
          this.paymentCustomerId = counselingUserData.data.getUser.paymentCustomerId
          this.paymentSubscriptionStatus = counselingUserData.data.getUser.paymentSubscriptionStatus
          this.paymentSubscriptionStartAt = counselingUserData.data.getUser.paymentSubscriptionStartAt
          this.paymentSubscriptionEndAt = counselingUserData.data.getUser.paymentSubscriptionEndAt
          this.paymentManagementButtonHidden = this.getForcePaidMode(counselingUserData.data.getUser.paymentSubscriptionId)
          this.paymentMode = this.getPaymentMode(this.paymentSubscriptionStatus, this.paymentSubscriptionStartAt, this.paymentSubscriptionEndAt)
          this.paymentCustomerPortalApiUrl = 'https://' + this.getPaymentApiDomain(location.hostname) + '/subscription/customerPortal'
        }

        this.profileDisplayName = counselingUserData.data.getUser.displayName
        if (counselingUserData.data.getUser.gender && (counselingUserData.data.getUser.gender !== '-')) {
          this.profileGender = counselingUserData.data.getUser.gender
        } else {
          this.profileGender = ''
        }
        if (counselingUserData.data.getUser.birthDate !== '0000-01-01') {
          this.profileAge = this.getAge(counselingUserData.data.getUser.birthDate)
        } else {
          this.profileAge = ''
        }
        this.profileRelationship = counselingUserData.data.getUser.relationship
        if (counselingUserData.data.getUser.cancerType && counselingUserData.data.getUser.cancerType !== '""') {
          this.profileCancerType = JSON.parse(counselingUserData.data.getUser.cancerType).join('、')
        } else {
          this.profileCancerType = ''
        }
        this.profileCancerStage = counselingUserData.data.getUser.cancerStage
        this.profileDiagnosedReason = counselingUserData.data.getUser.diagnosedReason
        this.profileDiagnosedDate = counselingUserData.data.getUser.diagnosedDate
        this.profileHospitalName = counselingUserData.data.getUser.hospitalName
        this.profileCurativeStatus = counselingUserData.data.getUser.curativeStatus
        this.profileCancerHistory = counselingUserData.data.getUser.cancerHistory
        this.profileIconDefaultUrl = counselingUserData.data.getUser.iconDefaultUrl
        this.profileIconUrl = this.download(counselingUserData.data.getUser.iconImageKey, counselingUserData.data.getUser.iconUploadedIdentityId)

        this.consentHamaMEDResearch = counselingUserData.data.getUser.consentHamaMEDResearch
        this.patientIdHamaMEDHospital = counselingUserData.data.getUser.patientIdHamaMEDHospital

        // 「がんと診断された年月日」が入力されている && 
        //    「現在の状況」が「治療中（初回）」「治療中（再発）」「治療完了」「継続治療中（ホルモン療法、免疫療法ほか）」 のとき
        if (this.profileDiagnosedDate && 
          (this.profileCurativeStatus === '治療中（初回）' || this.profileCurativeStatus === '治療中（再発）'
          || this.profileCurativeStatus === '治療完了' || this.profileCurativeStatus === '継続治療中（ホルモン療法、免疫療法ほか）')) {

          // this.profileDiagnosedDate から現在までの日数を算出（TODO：「◯年◯日」の形式で計算）
          var today = moment()
          var diagnosedDate = moment(this.profileDiagnosedDate, 'YYYY-MM-DD')
          this.surviveDate = today.diff(diagnosedDate, 'days') + '日'
          this.enableSurviveModule = true
        }
      } catch (err) {
        /*
        logger.error(err)
        Analytics.record({
          name: 'errorLog', 
          attributes: { 
            page: 'Profile',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'getUser : get profile user data(' + this.$route.params.userId + ')',
            errorNumber: 'Profile-03',
            errorMessage: err
          }
        });

        const errorLog = {
          type: 'errorLog',
          page: 'Profile',
          url: window.location.origin + window.location.pathname,
          userid: this.id,
          userType: this.userType,
          errorType: 'getUser : get profile user data(' + this.$route.params.userId + ')',
          errorNumber: 'Profile-03',
          errorMessage: err,
          addUser: 'system',
          createAt: new Date()
        }
        API.graphql(graphqlOperation(
          createErrorLog, { input: errorLog }
        ))
        */
      }

      // タイムラインデータの取得
      try {
        let timelineData = await API.graphql(graphqlOperation(
          listTimelinesBySpecificUser, {userid: this.$route.params.userId, limit: 1}
        ))

        this.timelineContents = JSON.parse(timelineData.data.listTimelinesBySpecificUser.items[0].timelineContents)
        this.isNew = false
        this.timelineId = timelineData.data.listTimelinesBySpecificUser.items[0].id

        // 全部ループさせ、futureかどうかチェックして「this.timelineContents[i].isFuture」を追加
        for (let i = 0; i < this.timelineContents.length; i++) {
          let nowDate = new Date()
          let targetDate = new Date(this.timelineContents[i].selectedStartYear, this.timelineContents[i].selectedStartMonth - 1, 1, 0, 0, 0)
          if (nowDate.getTime() < targetDate.getTime()) {
            this.timelineContents[i].isFuture = true
          } else {
            this.timelineContents[i].isFuture = false
          }
        }
        this.isLoading = false



      } catch (err) {
        this.isNew = true
        /*
        logger.error(err)
        Analytics.record({
          name: 'errorLog', 
          attributes: { 
            page: 'Profile',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'getTimeline : get timeline user data(' + this.$route.params.userId + ')',
            errorNumber: 'Profile-04',
            errorMessage: err
          }
        });

        const errorLog = {
          type: 'errorLog',
          page: 'Profile',
          url: window.location.origin + window.location.pathname,
          userid: this.id,
          userType: this.userType,
          errorType: 'getTimeline : get timeline user data(' + this.$route.params.userId + ')',
          errorNumber: 'Profile-04',
          errorMessage: err,
          addUser: 'system',
          createAt: new Date()
        }
        API.graphql(graphqlOperation(
          createErrorLog, { input: errorLog }
        ))
        */
      }


      this.isLoading = false
    }

    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'Profile',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: this.userType,
        counselingTopicsId: this.counselingId
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      if (this.userType === 'user') {
        this.$gtag.pageview({
          page_path: '/user/profile',
          page_title: 'User:プロフィール (/profile)'
        })
      } else if (this.userType === 'adviser') {
        this.$gtag.pageview({
          page_path: '/adviser/profile',
          page_title: 'Adviser:プロフィール (/profile)'
        })
      }
    }
  }
};
</script>

<style src="./assets/style.css" />
